import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { inject, observer } from 'mobx-react';

import { airForm } from '../../../commonComponents';
import { Form, Checkbox, Modal, Layout, Row, Input, Button, Radio } from 'antd';

import './PersonalDataModal.css';
import K from "../../../services/constants";

const { Content } = Layout;

@inject('translationsStore', 'step3RegistrationStore', 'profileStore')
@observer
class PersonalDataModal extends Component {
  componentDidMount() {
    this.setFieldsValue();
  }

  setFieldsValue() {
    this.props.form.setFieldsValue(this.props.step3RegistrationStore.formValues.personalData);
  }

  onOk = () => {
    if (this.props.onOk) this.props.onOk();
    ['agreementProfiling', 'agreementMarketing', 'agreementThirdParties'].forEach(agreement => {
      const checked = ((this[agreement] || {}).props || {}).hasOwnProperty('checked') ? this[agreement].props.checked : this.props.form.getFieldValue(agreement);
      this.props.step3RegistrationStore.setFormField(`personalData.${agreement}`, checked);
    });
    this.setFieldsValue();
    window._iub.cons_instructions.push(["init", {api_key: K.IUBENDA_API_KEY}]);
    const secondIubendaArgument = {
      consent: {
        subject: {
          id: this.props.step3RegistrationStore.registrationStore.formValues.step_1.car.plate,
          email: this.props.step3RegistrationStore.registrationStore.user.email,
          mobile : this.props.step3RegistrationStore.registrationStore.user.mobile
        },
        preferences: {
          "profiling_policy": this.props.step3RegistrationStore.formValues.personalData.agreementProfiling,
          "marketing_policy" : this.props.step3RegistrationStore.formValues.personalData.agreementMarketing,
          "third_party_policy": this.props.step3RegistrationStore.formValues.personalData.agreementThirdParties
        },
        legal_notices: [
          {
            identifier: "profiling_policy"
          },
          {
            identifier: "marketing_policy"
          },
          {
            identifier: "third_party_policy"
          }
        ],
        proofs: [
          {
            content: JSON.stringify({'email' : this.props.step3RegistrationStore.registrationStore.user.email, 'phone': this.props.step3RegistrationStore.registrationStore.user.mobile , 'agreementMarketing' : this.props.step3RegistrationStore.formValues.personalData.agreementMarketing, 'agreementProfiling' : this.props.step3RegistrationStore.formValues.personalData.agreementProfiling, 'agreementThirdParties' : this.props.step3RegistrationStore.formValues.personalData.agreementThirdParties}),
            form: document.getElementsByName('personalDataModal')[0].outerHTML
          }
        ]
      }
    };
    window._iub.cons_instructions.push(["submit",   secondIubendaArgument,
      {
        error: (response) => {
          throw `iubenda error, ${response}`;
        }
      }
    ]);
  };

  onCancel = () => {
    if (this.props.onCancel) this.props.onCancel();
    this.setFieldsValue();
  };

  Checkbox = (agreement, label) =>
    this.props.WithDecorator(agreement, label, {})(<Checkbox ref={el => (this[agreement] = el)} checked={this.props.form.getFieldValue(agreement)} />);

  Radio = (agreement, labelTrue, labelFalse) => {
    const { getFieldDecorator } = this.props.form;
    return getFieldDecorator(agreement)(
      <Radio.Group>
        <Radio value={true}>{labelTrue}</Radio>
        <Radio value={false}>{labelFalse}</Radio>
      </Radio.Group>
    );
  };

  Footer = () => {
    const {
      translationsStore: { current: t },
      form: { getFieldValue }
    } = this.props;
    const agreementsInvalid =
      getFieldValue('agreementProfiling') === undefined || getFieldValue('agreementMarketing') === undefined || getFieldValue('agreementThirdParties') === undefined;
    return (
      <Row>
        <Button type="dashed" onClick={this.onCancel}>
          Cancel
        </Button>
        <Button type="primary" onClick={this.onOk} disabled={!this.props.step3RegistrationStore.formValues.personalData.read || agreementsInvalid}>
          {this.props.step3RegistrationStore.formValues.personalData.read ? t['shared']['lblConfirmYourChoice'] : t['shared']['lblReadGreements']}
        </Button>
      </Row>
    );
  };

  render() {
    const {
      profileStore,
      visible,
      translationsStore: { current: t }
    } = this.props;

    return (
      <Modal
        className="PersonalDataModal"
        visible={visible}
        onCancel={this.onCancel}
        onOk={this.onOk}
        width={'95%'}
        closable={false}
        afterClose={() => this.props.onClose && this.props.onClose()}
        footer={this.Footer()}
      >
        <Form name="personalDataModal">
          {this.props.WithDecorator('read', '')(<Input type="hidden" />)}
          <Layout>
            <Content>
              <Row>
                <Row>{t['registration_3']['lblPrivacyAgreementProfiling']}:</Row>
                <Row className="radiogroupContainer">
                  {this.Radio('agreementProfiling', t['registration_3']['chkPrivacyAgreementProfilingTrue'], t['registration_3']['chkPrivacyAgreementProfilingFalse'])}
                </Row>
              </Row>

              <Row>
                <Row>{t['registration_3']['lblPrivacyAgreementMarketing']}:</Row>
                <Row className="radiogroupContainer">
                  {this.Radio('agreementMarketing', t['registration_3']['chkPrivacyAgreementMarketingTrue'], t['registration_3']['chkPrivacyAgreementMarketingFalse'])}
                </Row>
              </Row>
              <Row>
                <Row>
                  {t['registration_3']['lblPrivacyAgreementThirdParties']
                    .replace('##RAGSOC##', profileStore.profile.ragsoc)
                    .replace('##ADDRESS##', profileStore.profile.address)
                    .replace('##NUMBER##', profileStore.profile.number)
                    .replace('##CITY##', profileStore.profile.city)
                    .replace('##POSTCODE##', profileStore.profile.postcode)
                    .replace('##PROV##', profileStore.profile.prov)}
                  :
                </Row>
                {profileStore.profile.personalcode === ('04051510982' || '01821270202') && (
                  <Row>
                    Infine, con la firma di seguito apposta il sottoscritto conferma di essere stato adeguatamente informato e di aver compreso che la comunicazione di taluni
                    propri dati personali al Centro di Assistenza Autorizzato avviene allo scopo di consentire a quest’ultimo di dare esecuzione agli accordi contrattuali
                    intrattenuti con il sottoscritto (come da art. 2 lett. c) dell’informativa) e che, in relazione a tale comunicazione, non si rende pertanto necessario il
                    consenso.
                  </Row>
                )}
                <Row className="radiogroupContainer">
                  {this.Radio('agreementThirdParties', t['registration_3']['chkPrivacyAgreementThirdPartiesTrue'], t['registration_3']['chkPrivacyAgreementThirdPartiesFalse'])}
                </Row>
              </Row>
            </Content>
          </Layout>
        </Form>
      </Modal>
    );
  }
}

PersonalDataModal.propTypes = {
  onOk: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func
};

export default Form.create()(airForm(PersonalDataModal));



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/PersonalDataModal.js